import { render, staticRenderFns } from "./OfferServiceForm.vue?vue&type=template&id=6f59d4a0&scoped=true&"
import script from "./OfferServiceForm.vue?vue&type=script&lang=js&"
export * from "./OfferServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./OfferServiceForm.vue?vue&type=style&index=0&id=6f59d4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59d4a0",
  null
  
)

export default component.exports